import React, { PropsWithChildren, useEffect } from 'react';
import { useLoggedInUser } from 'features/auth/hooks/useAuthData';
import { initializePendo } from './utils/pendoUtils';
import { setupPendoScript } from './utils/pendoScriptUtils';

export const PendoWrapper = ({ children }: PropsWithChildren) => {
  const user = useLoggedInUser();

  useEffect(() => {
    setupPendoScript().catch((error) => {
      console.error('Error loading Pendo script on mount:', error);
    });
  }, []);

  useEffect(() => {
    initializePendo(user?.id, user?.hospital.id);
  }, [user?.hospital.id, user?.id]);

  return <>{children}</>;
};
